export default "__VITE_ASSET__DfNSEEW0__"